import axios from '../utils/axios';

const shopifyService = {
  getFeatureStatus: () => axios.get('/shopify/feature-status').then((r) => r.data),
  getConfig: () => axios.get('/shopify/config').then((r) => r.data),
  saveConfig: (data) => axios.post('/shopify/config', data).then((r) => r.data),
  testConnection: () => axios.get('/shopify/test-connection').then((r) => r.data),
  syncOrders: () => axios.post('/shopify/sync-orders').then((r) => r.data),
  syncProducts: () => axios.post('/shopify/sync-products').then((r) => r.data),
  syncInventory: () => axios.post('/shopify/sync-inventory').then((r) => r.data),
  getProductMappings: (page = 0, size = 50) =>
    axios.get('/shopify/product-mappings', { params: { page, size } }).then((r) => r.data),
  listOrders: (page = 0, size = 20) =>
    axios.get('/shopify/orders', { params: { page, size } }).then((r) => r.data),
  getOrder: (mappingId) => axios.get(`/shopify/orders/${mappingId}`).then((r) => r.data),
  retryOrder: (mappingId) => axios.post(`/shopify/orders/${mappingId}/retry`).then((r) => r.data),
  getSyncLogs: (page = 0, size = 50) =>
    axios.get('/shopify/sync-logs', { params: { page, size } }).then((r) => r.data),
};

export default shopifyService;
